import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { FaBars, FaTimes, FaCaretDown } from "react-icons/fa";
import SearchTypeahead from "web/components/SearchTypeahead";
import { IconContext } from "react-icons/lib";
import headerLogo from "web/assets/images/NewHeaderLogo.png";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';
import UserPic from "web/assets/images/new_userpic.png";
import ManageAccountDropDownMenu from "web/components/ManageAccountDropDownMenu";
import DropDownMenuNearBy from "web/components/DropDownMenuNearBy";
import DropDownMenuPost from "web/components/DropDownMenuPost";
import DropDownMenuPostPallets from "web/components/DropDownMenuPostPallets";
import DropDownMenuMyBids from "web/components/DropDownMenuMyBids";
import DropDownMenuMyOrders from "web/components/DropDownMenuMyOrders";
import DropDownPtPlus from "web/components/DropDownPtPlus";
import AdditionalItemsDropDownMenu from "web/components/AdditionalItemsDropDownMenu";
import DropDown from "web/components/DropDown";
import notification from "web/assets/images/notification-icon.png";
import { notificationCountApi } from "redux/actions/notification";
import { maintenanceApi } from "redux/actions/notification";
import AdvanceSearch from "web/components/AdvanceSearch";
import HeartIcon from "web/assets/svg/HeartIcon";
import AlertModal from "web/components/AlertModal";
import "./navbar.scss";
import { SearchWraper, SearchSection, SearchContainer, AdvanceSearchDiv, DropDownDiv, BlankSection, UserDropDown, } from "./navbarStyled";
import { fetchLanguageContentNew } from "redux/actions/language";
import { requestOrderCountApi, orderChatCountApi } from 'redux/actions/notificationCount';
import { toggleGuestUpgradeModal } from "redux/actions/app";

const Navbar = ({ userType, pageType, tabType, selectedSearch, topBarViewMobile }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const typeahead = useRef(null);
  const ref = useRef();
  const [navbarDropDownsToggleHandle, setNavbarDropDownsToggleHandle] = useState(undefined)
  const [searchDropDown, setSearchDropDown] = useState("PostInventory");

  const [notificationResponse, setNotificationResponse] = useState();
  const [maintainceValue, setMaintainceValue] = useState(0);

  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);

  // const orderChatCount = useSelector((state) => state.notificationCount?.orderChatCount)
  const storedData = useSelector((state) => state.storedData.payload);
  const ptPlusRequestsOrderCount = useSelector((state) => state.notificationCount?.ptPlusRequestsOrderCount)

  const [pageLanguageContents, setPageLanguageContents] = useState();
  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);

  let title = "";
  let defaulTitle = localStorage.getItem("titleInput");
  const [advanceModal, setAdvanceModal] = useState(false);
  const advanceModalToggleModal = () => setAdvanceModal(!advanceModal);
  const searchSectionRestrictedPages = ["Dashboard", "myCommunity", "postLoad", "postInventory", "PtPlusPage", "ManageAccount", "ManageLocations", "orderPage"];

  let accountType = localStorage.getItem("accountType");

  if (accountType === "Reseller") accountType = "Both"
  if (userType === undefined) userType = localStorage.getItem("userType")

  const userName = localStorage.getItem("userName");
  const truncateUserName = userName && userName.length > 10 ? userName.substring(0, 10).concat("...") : userName;

  const cardExpiryDetails = useSelector((state) => state.authReducer.cardExpiryDetails);
  let isSubscriptionCardExpired = cardExpiryDetails.subscriptionCardExpired;

  let loggedUserInnerCircle = true;

  let greyOutField = false;
  if (isSubscriptionCardExpired || !loggedUserInnerCircle) greyOutField = true;

  useEffect(() => {
    if (languageContentNew?.Header_Page) setPageLanguageContents(languageContentNew.Header_Page);
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  useEffect(() => {
    const elements = document.querySelectorAll(".opacityDisableMyCommunity, .opacityDisable");
    const handleClick = (e) => dispatch(toggleGuestUpgradeModal(true));
    elements.forEach((item) => item.addEventListener("click", handleClick));
    return () => {
      elements.forEach((item) => item.removeEventListener("click", handleClick));
    };
  }, [dispatch])

  useEffect(() => {
    let locationId = localStorage.getItem('locationId')
    const intervalCall = setInterval(() => {
      dispatch(requestOrderCountApi(token));
      // dispatch(orderChatCountApi(token, locationId));
    }, 10000)

    return () => {
      clearInterval(intervalCall)
    }
  }, [])

  useEffect(() => {
    let obj = { ...storedData, guestUser: accountType === "Guest" };
    dispatch({ type: 'LOCAL_STORE_DATA', payload: obj });
  }, [accountType])

  useEffect(() => {
    document.body.addEventListener("click", onMouseLeave);
    if (selectedSearch === "PostLoad" || selectedSearch === "MyPostLoad") {
      setSearchDropDown("PostLoad");
    }
    if (accountType === "Seller" && (selectedSearch === "MyOfferBids" || selectedSearch === "MyPostLoad")) {
      setSearchDropDown("PostLoad");
    }
    setNotificationResponse();

    fetchMyAPI();
    // setInterval(fetchmaintenanceApi, 7000);
    // fetchmaintenanceApi()

    return () => {
      document.body.removeEventListener("click", onMouseLeave);
    };
  }, []);

  const onMouseLeave = (e) => {
    if (!e.target.closest('.nav-item')) {
      setNavbarDropDownsToggleHandle(undefined)
    }
  };

  const fetchMyAPI = async () => {
    // maintenanceApi()
    let response = await dispatch(notificationCountApi(token));
    if (response.success) {
      setNotificationResponse(response.data);
    }
  };

  const fetchmaintenanceApi = async () => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/sign-in");
      toggleModal();
    } else {
      let response = await dispatch(maintenanceApi(token));
      setMaintainceValue(response)
    }
  };

  const dropDownArr = [];
  const addDropDownItem = (id, label, value) => {
    dropDownArr.push({ id, label, value });
  };
  const isSeller = accountType === "Seller";
  const isBuyer = accountType === "Buyer";
  const isBoth = accountType === "Both";
  const palletOffers = pageLanguageContents?.SearchBarDiv[1]?.PalletOffers;
  const palletNeeds = pageLanguageContents?.SearchBarDiv[2]?.PalletNeeds;
  if (isSeller || isBuyer) {
    if (selectedSearch === "PostInventory" || (isBuyer && selectedSearch === undefined)) {
      addDropDownItem("0", palletOffers, "PostInventory");
    }
    if (selectedSearch === "PostLoad" || selectedSearch === "MyPostLoad") {
      addDropDownItem("0", palletNeeds, "PostLoad");
    }
    if (selectedSearch === "MyOfferBids") {
      addDropDownItem("0", palletNeeds, "PostLoad");
    }
  }
  if (isBoth) {
    addDropDownItem("0", palletOffers, "PostInventory");
    addDropDownItem("1", palletNeeds, "PostLoad");
  }

  const nearbyClickHandle = (e) => {
    e.stopPropagation()
    let nearBySelectedPageObj = { nearBySelectedPage: 1, }
    dispatch({ type: 'NEARBY_PAGINATION', payload: nearBySelectedPageObj })
    setNavbarDropDownsToggleHandle(navbarDropDownsToggleHandle === 'nearbyDropdown' ? undefined : 'nearbyDropdown')
  };

  const postClickHandle = (e) => {
    e.stopPropagation()
    let obj = { type: "PostInventory", activePage: "PostInventory", }
    dispatch({ type: 'POST_INVENTORY_URL', payload: obj })
    setNavbarDropDownsToggleHandle(navbarDropDownsToggleHandle === 'postDropdown' ? undefined : 'postDropdown')
  };

  const myPostsClickHandle = (e) => {
    e.stopPropagation()
    let paginationObj = { selectedPage: 1, }
    dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
    setNavbarDropDownsToggleHandle(navbarDropDownsToggleHandle === 'myPostsDropdown' ? undefined : 'myPostsDropdown')
  };

  const myBidsOffersClickHandle = (e) => {
    e.stopPropagation()
    setNavbarDropDownsToggleHandle(navbarDropDownsToggleHandle === 'myBidsOffersDropdown' ? undefined : 'myBidsOffersDropdown')
  }

  const myOrdersClickHandle = (e) => {
    e.stopPropagation()
    let myOrderSelectedPageObj = { myOrderSelectedPage: 1, }
    dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
    let obj = { pageType: "MyOrder", expanded: "sideBar" }
    dispatch({ type: 'ORDERS', payload: obj })
    setNavbarDropDownsToggleHandle(navbarDropDownsToggleHandle === 'myOrdersDropdown' ? undefined : 'myOrdersDropdown')
  }

  const ptPlusPagesClickHandle = (e) => {
    e.stopPropagation()
    setNavbarDropDownsToggleHandle(navbarDropDownsToggleHandle === 'ptPlusDropdown' ? undefined : 'ptPlusDropdown')
  };

  const manageAccountClickHandle = (e) => {
    e.stopPropagation()
    setNavbarDropDownsToggleHandle(navbarDropDownsToggleHandle === 'manageAccountDropdown' ? undefined : 'manageAccountDropdown')
  };

  const additionalItemsClickHandle = (e) => {
    e.stopPropagation()
    let paginationObj = { selectedPage: 1, }
    dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
    setNavbarDropDownsToggleHandle(navbarDropDownsToggleHandle === 'additionalItemsDropdown' ? undefined : 'additionalItemsDropdown')
  }

  const myWishList = () => {
    let obj = {
      id: '',
      postType: 'PostLoad',
    }
    dispatch({ type: 'DETAILS', payload: obj })
    let params = '?params=true'
    let obj1 = {
      params,
      pageType: 'PostInventory',
      tabType: 'WishList',
      expanded: 'sideBar'
    }
    dispatch({ type: 'SEARCH_INVENTORY', payload: obj1 })
    let paginationObj = { selectedPage: 1, }
    dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
    history.push('/wish-list')
  };

  let disableFlg
  if (accountType === "Guest") disableFlg = true
  else disableFlg = false

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <nav className="navbar">
          <div className="nav-warpper">
            <div className="navbar-container">
              <div className="menu-icon" onClick={handleClick}>
                {click ? <FaTimes /> : <FaBars />}
              </div>
              <Link
                to="/dashboard"
                className="navbar-logo"
                onClick={() => {
                  let paginationObj = { selectedPage: 1, }
                  dispatch({ type: 'BIDS_PAGINATION', payload: paginationObj })
                  localStorage.setItem("titleInput", "");
                }}
              >
                <img src={headerLogo} className="logo" alt="headerLogo" />
              </Link>

              <ul className={`${click ? "nav-menu active" : "nav-menu new-header"} ${greyOutField && "event"}`}>
                <li className="nav-item mobile-view">
                  <div className="nav-link user-name">
                    <div className="w-100">
                      <p>{pageLanguageContents?.Header[6]?.H7_Greetings}
                        , {truncateUserName}</p>
                    </div>
                  </div>
                </li>
                <li
                  className="nav-item event-li"
                  onClick={nearbyClickHandle}
                >
                  <div className={`nav-link ${(selectedSearch === "PostLoad" || selectedSearch === "PostInventory") && !tabType && "active"}`}>
                    NEARBY<FaCaretDown style={{ color: "inherit" }} />
                  </div>
                  {navbarDropDownsToggleHandle === 'nearbyDropdown' && (
                    <UserDropDown>
                      <DropDownMenuNearBy content={pageLanguageContents} />
                    </UserDropDown>
                  )}
                </li>
                <li
                  className={`${isSubscriptionCardExpired ? "nav-item event-li" : "nav-item"}`}
                  onClick={postClickHandle}
                >
                  <div
                    className={`nav-link ${(pageType === "postLoad" || pageType === 'postInventory') && !tabType && "active"}`}>
                    POST<FaCaretDown style={{ color: "inherit" }} />
                  </div>
                  {navbarDropDownsToggleHandle === 'postDropdown' && (
                    <UserDropDown>
                      <DropDownMenuPostPallets content={pageLanguageContents} />
                    </UserDropDown>
                  )}
                </li>
                <li
                  className="nav-item event-li"
                  onClick={myPostsClickHandle}
                >
                  <div className={`nav-link ${selectedSearch === "MyPostLoad" && !tabType && "active"}`}>
                    {pageLanguageContents?.Header[17]?.H_MyPosts}
                    <FaCaretDown style={{ color: "inherit" }} />
                  </div>
                  {navbarDropDownsToggleHandle === 'myPostsDropdown' && (
                    <UserDropDown>
                      <DropDownMenuPost content={pageLanguageContents} />
                    </UserDropDown>
                  )}
                </li>
                <li
                  className="nav-item event-li"
                  onClick={myBidsOffersClickHandle}
                >
                  <div
                    className={`nav-link ${selectedSearch === "MyOfferBids" && !tabType && "active"}`}>
                    {pageLanguageContents?.Header[20]?.H_MyBids}
                    <FaCaretDown style={{ color: "inherit" }} />
                  </div>
                  {navbarDropDownsToggleHandle === 'myBidsOffersDropdown' && (
                    <UserDropDown>
                      <DropDownMenuMyBids content={pageLanguageContents} />
                    </UserDropDown>
                  )}
                </li>
                {(storedData?.data?.isEnablePickupFeature || storedData?.data?.isEnablePtPlusFeature) ?
                  <li
                    className="nav-item event-li"
                    onClick={myOrdersClickHandle}
                  >
                    <div className={`nav-link ${pageType === "orderPage" && !tabType && "active"}`}>
                      MY ORDERS<FaCaretDown style={{ color: "inherit" }} />
                    </div>
                    {navbarDropDownsToggleHandle === 'myOrdersDropdown' && (
                      <UserDropDown>
                        <DropDownMenuMyOrders content={pageLanguageContents} />
                      </UserDropDown>
                    )}
                  </li>
                  :
                  <li className="nav-item event-li">
                    <div
                      className={`nav-link ${pageType === "orderPage" && "active"}`}
                      onClick={() => {
                        let myOrderSelectedPageObj = {
                          myOrderSelectedPage: 1,
                        }
                        dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
                        let obj = {
                          pageType: "MyOrder",
                          expanded: "sideBar"
                        }
                        dispatch({ type: 'ORDERS', payload: obj })
                        history.push('/my-orders');
                      }}
                    >
                      {pageLanguageContents?.Header[4]?.H5_Orders}
                      {/* {orderChatCount > 0 && <div><span className="notificationCountOrderChatStyle">{orderChatCount}</span></div>} */}
                    </div>
                  </li>
                }
                <li className="nav-item event-li mobile-view">
                  <div
                    className={`nav-link ${pageType === "resolution" && "active"}`}
                    onClick={() => {
                      let obj = {
                        selectedTab: "CLAIM_RAISED",
                        expanded: "sideBar"
                      }
                      dispatch({ type: 'RESOLUTION_CENTER', payload: obj })
                      history.push('/resolution-center');
                    }}
                  >
                    Resolution Center
                  </div>
                </li>
                <li className={isSubscriptionCardExpired ? "nav-item event-li" : "nav-item"}>
                  {disableFlg ?
                    <div className={`nav-link opacityDisableMyCommunity  ${pageType === "myCommunity" && "active"}`}>My COMMUNITY</div>
                    :
                    <div
                      className={`nav-link ${pageType === "myCommunity" && "active"}`}
                      onClick={() => {
                        localStorage.setItem("titleInput", "");
                        let obj = {
                          pageType: "MyCommunity",
                          expanded: "sideBar"
                        }
                        dispatch({ type: 'MYCOMMUNITY', payload: obj })
                        history.push('/my-community');
                      }}
                    >
                      {pageLanguageContents?.Header[2]?.H3_Community}
                    </div>}
                </li>
                {storedData?.data?.isEnablePtPlusFeature &&
                  <li
                    className="nav-item event-li"
                    onClick={ptPlusPagesClickHandle}
                  >
                    <div className={`nav-link ${pageType === "PtPlusPage" && "active"}`}>
                      PT+
                      {ptPlusRequestsOrderCount > 0 && <div><span className="notificationCountReqOrderStyle">{ptPlusRequestsOrderCount}</span></div>}
                      <FaCaretDown style={{ color: "inherit" }} />
                    </div>
                    {navbarDropDownsToggleHandle === 'ptPlusDropdown' && (
                      <UserDropDown>
                        <DropDownPtPlus content={pageLanguageContents} />
                      </UserDropDown>
                    )}
                  </li>
                }
                <li className="nav-item mobile-menu event-li">
                  <div
                    className={`nav-link ${pageType === "reports" && "active"}`}
                    onClick={() => {
                      localStorage.setItem("titleInput", "");
                      history.push('/order-reports');
                    }}
                  >
                    {pageLanguageContents?.Header[11]?.H8_Nav_Orders}
                  </div>
                </li>
                <li className={isSubscriptionCardExpired ? "nav-item mobile-menu event-li" : "nav-item mobile-menu"}>
                  <div
                    className={`nav-link ${pageType === "specifications" && "active"}`}
                    onClick={() => {
                      localStorage.setItem("titleInput", "");
                      history.push('/specifications');
                    }}
                  >
                    Pallet Spec Library
                  </div>
                </li>
                <li className={isSubscriptionCardExpired ? "nav-item mobile-menu event-li" : "nav-item mobile-menu"}>
                  <div
                    className={`nav-link ${pageType === "operational" && "active"}`}
                    onClick={() => {
                      localStorage.setItem("titleInput", "");
                      history.push('/operational-terms-and-conditions');
                    }}
                  >
                    Operational T&C
                  </div>
                </li>
                <li className="nav-item mobile-menu">
                  <div
                    className={`nav-link ${pageType === "auth" && "active"}`}
                    onClick={() => {
                      dispatch(logoutAdmin())
                      dispatch(logoutClearRedux())
                      localStorage.clear()
                      sessionStorage.clear()
                      localStorage.setItem("titleInput", "");
                      history.push('/sign-in');
                    }}
                  >
                    {pageLanguageContents?.Header[12]?.H8_Nav_Logout}
                  </div>
                </li>
              </ul>
              <ul
                className='right-menu event'>
                <li
                  className="nav-item web-view"
                  onClick={manageAccountClickHandle}
                >
                  <div className="nav-link user-name" handleClick={() => { }}>
                    <img className="userPic" src={UserPic} alt="userPic" />
                    <FaCaretDown
                      style={{ color: "inherit" }}
                      className="down-arrow-icon-mobile"
                    />
                    <div className="user-id">
                      <p>{pageLanguageContents?.Header[6]?.H7_Greetings},{" "}</p>
                      <p>{truncateUserName}{" "}<FaCaretDown style={{ color: "inherit" }} /></p>
                    </div>
                  </div>
                  {navbarDropDownsToggleHandle === 'manageAccountDropdown' && (
                    <UserDropDown>
                      <ManageAccountDropDownMenu content={pageLanguageContents} />
                    </UserDropDown>
                  )}
                </li>
                <li className="nav-item">
                  <div
                    className="nav-link"
                    onClick={() => {
                      let obj = { pageType: 'Notification', }
                      dispatch({ type: 'NOTIFICATION', payload: obj })
                      history.push({ pathname: "/notification", });
                    }}
                  >
                    <img src={notification} alt="logo" />
                    {(notificationResponse && notificationResponse !== 0) && (
                      <p className="notification">{notificationResponse}</p>
                    )}
                  </div>
                </li>
                <li className="nav-item">
                  <div
                    className="nav-link"
                    onClick={myWishList}
                  >
                    <HeartIcon />
                  </div>
                </li>
                <li
                  className="nav-item web-view-menu"
                  onClick={additionalItemsClickHandle}
                >
                  <div className="nav-link">
                    <FaBars color="inherit" />
                  </div>
                  <DropDownDiv ref={ref}>
                    {navbarDropDownsToggleHandle === 'additionalItemsDropdown' && (
                      <AdditionalItemsDropDownMenu content={pageLanguageContents} />
                    )}
                  </DropDownDiv>
                </li>
              </ul>
            </div>
            {maintainceValue === 1 &&
              <nav className="navbar  nav justify-content-center" style={{ backgroundColor: "#95cce9" }}>
                <span style={{ marginTop: "1%", color: "red" }}><center>We apologize for the inconvenience, but we are performing some urgent maintenance,</center></span>
                <span style={{ marginBottom: "", color: "red" }}><center>and would like to recommend you not to perform any important operation or payment & order transaction during this time of ongoing maintenance.  </center></span>
                <span style={{ marginBottom: "1%", color: "red" }}><center><strong>In any emergency case you can still reach us at support@pallettrader.com or contact us 1-877-777-7495</strong></center></span>
              </nav>
            }
          </div >

          <div className={loggedUserInnerCircle && !isSubscriptionCardExpired ? "advancedSearch-event" : "fc-advancedSearch-event"}>
            {!searchSectionRestrictedPages.includes(pageType) && (
              <div style={{ boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)", width: "100%", }}>
                <SearchContainer>
                  <BlankSection></BlankSection>
                  <SearchWraper>
                    {pageType !== "SearchPostScreen" && (
                      <div style={{ minWidth: "238px" }} className={topBarViewMobile === 'hide' && 'topbar-hide-mobile'}>
                        <DropDownDiv>
                          <DropDown
                            name="dropDown"
                            data={dropDownArr}
                            placeholder="Search By"
                            searchDropDown={searchDropDown}
                            onChangeHandler={(event) => {
                              setSearchDropDown(event.value);
                            }}
                          />
                        </DropDownDiv>
                      </div>
                    )}
                    <SearchSection className={topBarViewMobile === 'hide' && 'topbar-hide-mobile'}>
                      <SearchTypeahead
                        placeholder={pageLanguageContents?.Header[13]?.HeaderSearchPlaceholder}
                        focusOnShow={false}
                        typeahead={typeahead}
                        filterBy="title"
                        defaulTitle={defaulTitle}
                        title={title}
                        pageType={searchDropDown}
                        containerStyle="makeSearch"
                        color="#fff"
                      />
                    </SearchSection>
                    <AdvanceSearchDiv className={topBarViewMobile === 'hide' && 'topbar-hide-mobile'}
                      onClick={() => advanceModalToggleModal()}
                    >
                      {pageLanguageContents?.SearchBarDiv[0]?.AdvancedSearch}
                    </AdvanceSearchDiv>
                  </SearchWraper>
                </SearchContainer>
              </div>
            )}
          </div>
        </nav >
      </IconContext.Provider >

      <AdvanceSearch
        isOpen={advanceModal}
        toggle={advanceModalToggleModal}
        title=""
        onClickHander={(Obj) => { }}
        content=""
        link="/"
        pageType={searchDropDown}
      />

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title={title}
        content={modalContent}
        link={modalLink}
      />
    </>
  );
};

export default Navbar;
